// Environment configuration with fallback handling
// This ensures environment variables work in all deployment scenarios

interface EnvConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
}

// Runtime window type
declare global {
  interface Window {
    __ENV__?: any;
    __RUNTIME_ENV__?: any;
  }
}

// Simple config that Vite can handle
const VITE_SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const VITE_SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

// Export config object
export const envConfig: EnvConfig = {
  supabaseUrl: VITE_SUPABASE_URL || '',
  supabaseAnonKey: VITE_SUPABASE_ANON_KEY || ''
};

// Helper function to get runtime env if build-time env is empty
export function getRuntimeEnv(): EnvConfig {
  if (typeof window !== 'undefined') {
    const runtime = window.__RUNTIME_ENV__ || window.__ENV__ || {};
    return {
      supabaseUrl: envConfig.supabaseUrl || runtime.VITE_SUPABASE_URL || '',
      supabaseAnonKey: envConfig.supabaseAnonKey || runtime.VITE_SUPABASE_ANON_KEY || ''
    };
  }
  return envConfig;
}

// Helper function to check if environment is properly configured
export function isEnvConfigured(): boolean {
  const config = getRuntimeEnv();
  return !!(config.supabaseUrl && config.supabaseAnonKey);
}

// Debug function
export function debugEnv(): void {
  const config = getRuntimeEnv();
  // console.log('[env-config] Supabase URL:', config.supabaseUrl || 'NOT SET');
  // console.log('[env-config] Supabase Anon Key:', config.supabaseAnonKey ? `${config.supabaseAnonKey.substring(0, 20)}...` : 'NOT SET');
  if (typeof window !== 'undefined') {
    // console.log('[env-config] window.__RUNTIME_ENV__:', window.__RUNTIME_ENV__);
  }
}